// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__EVT03","row":"styles_row__RROV-"};